import { render, staticRenderFns } from "./ex-topic.vue?vue&type=template&id=896e2ef6&scoped=true&"
import script from "./ex-topic.vue?vue&type=script&lang=js&"
export * from "./ex-topic.vue?vue&type=script&lang=js&"
import style0 from "./ex-topic.vue?vue&type=style&index=0&id=896e2ef6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896e2ef6",
  null
  
)

export default component.exports